import {
  setAuthCredentials,
  throwErrorMessage,
  clearLocalStorageOnLogout,
} from 'dashboard/store/utils/api';
import wootAPI from './apiClient';
import { getLoginRedirectURL } from '../helpers/AuthHelper';

export const login = async ({
  ssoAccountId,
  ssoConversationId,
  ...credentials
}) => {
  try {
    const response = await wootAPI.post('auth/sign_in', credentials);

    // Check if MFA is required
    if (response.status === 206 && response.data.mfa_required) {
      // Return MFA data instead of throwing error
      return {
        mfaRequired: true,
        mfaToken: response.data.mfa_token,
      };
    }

    setAuthCredentials(response);
    clearLocalStorageOnLogout();
    window.location = getLoginRedirectURL({
      ssoAccountId,
      ssoConversationId,
      user: response.data.data,
    });
    return null;
  } catch (error) {
    // Check if it's an MFA required response
    if (error.response?.status === 206 && error.response?.data?.mfa_required) {
      return {
        mfaRequired: true,
        mfaToken: error.response.data.mfa_token,
      };
    }
    throwErrorMessage(error);
    return null;
  }
};

export const register = async creds => {
  try {
    const response = await wootAPI.post('api/v1/accounts.json', {
      account_name: creds.accountName.trim(),
      user_full_name: creds.fullName.trim(),
      email: creds.email,
      password: creds.password,
      h_captcha_client_response: creds.hCaptchaClientResponse,
      // Idioma escolhido na tela: a conta nasce nele.
      locale: creds.locale,
      // Código de indicação (?ref=) — atribui a conta nova à revenda.
      ref: creds.ref || undefined,
      // Pacote de contatos escolhido no cadastro: 'unlimited' ou ausente
      // (NUNCA -1); contacts_limit é o inteiro do pacote (1000/5000/40000).
      contacts_tier: creds.contactsTier || undefined,
      contacts_limit: creds.contactsLimit || undefined,
      // Demais recursos do passo 1. Ausentes quando o cliente não pediu extra —
      // mandar o incluído do plano congelaria o entitlement em custom_limits.
      inbox_limit: creds.inboxLimit || undefined,
      agent_limit: creds.agentLimit || undefined,
      storage_mb: creds.storageMb || undefined,
      modules: creds.modules || undefined,
      // Dados de cobrança (obrigatórios p/ gerar a fatura da assinatura).
      billing: {
        country: creds.country,
        person_type: creds.personType,
        document: creds.document,
        phone: creds.phone,
        postal_code: creds.postalCode,
        address: creds.address,
        address_number: creds.addressNumber,
        complement: creds.complement,
        province: creds.province,
        city: creds.city,
        state: creds.state,
      },
    });
    setAuthCredentials(response);
    return response.data;
  } catch (error) {
    throwErrorMessage(error);
  }
  return null;
};

export const verifyPasswordToken = async ({ confirmationToken }) => {
  try {
    const response = await wootAPI.post('auth/confirmation', {
      confirmation_token: confirmationToken,
    });
    setAuthCredentials(response);
  } catch (error) {
    throwErrorMessage(error);
  }
};

export const setNewPassword = async ({
  resetPasswordToken,
  password,
  confirmPassword,
}) => {
  try {
    const response = await wootAPI.put('auth/password', {
      reset_password_token: resetPasswordToken,
      password_confirmation: confirmPassword,
      password,
    });
    setAuthCredentials(response);
  } catch (error) {
    throwErrorMessage(error);
  }
};

export const resetPassword = async ({ email }) =>
  wootAPI.post('auth/password', { email });
